import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from 'react-redux';
import App from "./components/App"
import { store } from './redux/store'
const entry = document.getElementById('searchApp');


ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
    entry
)